// based on config returns the action functions

import makeAction from './makeAction'
import standardActions from './standardActions'

export default ({ config, common }) => {
  let actions = standardActions({ config, common })
  let extendedActions = {}
  Object.keys(common.actionTypes).forEach(actionType => {
    Object.keys(common.actionDefinitions[actionType]).forEach(name => {
      extendedActions[name] = makeAction({ actionType, name, config, common })
    })
  })
  return {
    ...actions,
    ...extendedActions
  }
}
